import React from 'react';
import { useTranslation } from 'react-i18next';

import { Flex, Button } from 'src/packages/core';
import { goToUrl } from 'src/utils/go-to-url';

import { config } from 'src/config';

export const HeaderGuestButtons = () => {
  const { t } = useTranslation();

  return (
    <Flex alignItems={'center'} justifyContent={'center'} gap={2}>
      <Button
        variant={'ghostSmall'}
        theme={'dark'}
        text={t('button.login')}
        minWidth={'90px'}
        onClick={() => {
          goToUrl(`${config.coinflareUrl}/login`);
        }}
      />
      <Button
        theme='dark'
        variant={'secondarySmall'}
        text={t('button.sign_up')}
        minWidth={'90px'}
        onClick={() => {
          goToUrl(`${config.coinflareUrl}/register`);
        }}
      />
    </Flex>
  );
};
